export const TASK_STATUSES = [
    'draft',
    'open',
    'in_progress',
    'completed',
    'cancelled',
];
export const TASK_PRIORITIES = ['low', 'normal', 'high'];
